<template>
  <div>
    <div class="table-draggable">
      <div class="table-header-row">
        <div
          v-for="(column, index) in columns"
          :key="index"
          :style="{ width: (column.width || '100%') }"
          class="column"
        >
          <div class="table-cell-inner">{{ column.title ? column.title : '' }}</div>
        </div>
      </div>
      <Container
        v-if="this.permissao"
        @drop="onDrop"
        lock-axis="y"
        drag-handle-selector=".drag-selector"
      >
        <Draggable v-for="(epico, e_index) in epicos" :key="epico.id">
          <div class="table-row">
            <div
              v-for="(column, index) in columns"
              :key="index"
              :style="{ width: (column.width || '100%') }"
              class="column table-cel"
              :class="{'drag-selector': enableDrag}"
            >
              <a
                v-if="column.type =='expand'"
                class="table-cell-with-expand"
                @click="expandir(e_index)"
              >
                <Icon v-if="!expanded" type="ios-arrow-forward" />
                <Icon v-if="expanded" type="ios-arrow-down" />
              </a>
              <div v-else class="table-cell-inner">
                <custom-render
                  v-if="column.render"
                  :row="epico"
                  :column="column"
                  :index="index"
                  :render="column.render"
                ></custom-render>
                {{ !column.render ? epico[column.key] : '' }}
              </div>
            </div>
          </div>
          <div
            v-if="epico.expanded"
            :style="{ width: '100%' }"
            class="table-row table-row-expanded"
          >
            <custom-render :row="epico" :column="columns[0]" :index="0" :render="columns[0].render"></custom-render>
          </div>
        </Draggable>
      </Container>
      <Container v-else @drop="onDrop" lock-axis="y" drag-handle-selector=".drag-selector">
        <Draggable v-for="(epico, e_index) in epicos" :key="epico.id">
          <div class="table-row">
            <div
              v-for="(column, index) in columns"
              :key="index"
              :style="{ width: (column.width || '100%') }"
              class="column table-cel"
              :class="{'drag-disabled': enableDrag}"
            >
              <a
                v-if="column.type =='expand'"
                class="table-cell-with-expand"
                @click="expandir(e_index)"
              >
                <Icon v-if="!expanded" type="ios-arrow-forward" />
                <Icon v-if="expanded" type="ios-arrow-down" />
              </a>
              <div v-else class="table-cell-inner">
                <custom-render
                  v-if="column.render"
                  :row="epico"
                  :column="column"
                  :index="index"
                  :render="column.render"
                ></custom-render>
                {{ !column.render ? epico[column.key] : '' }}
              </div>
            </div>
          </div>
          <div
            v-if="epico.expanded"
            :style="{ width: '100%' }"
            class="table-row table-row-expanded"
          >
            <custom-render :row="epico" :column="columns[0]" :index="0" :render="columns[0].render"></custom-render>
          </div>
        </Draggable>
      </Container>
    </div>
    <div v-if="this.permissao" class="floating-btn">
      <i-button @click="newEpico" type="primary" shape="circle" icon="md-add"></i-button>
    </div>

    <drawer placement="right" title="Épico" v-model="edit_epico.active" :width="widthDrawer">
      <epico :uuid="edit_epico.uuid" v-if="edit_epico.active" @update="onUpdate"></epico>
    </drawer>
  </div>
</template>

<script>
const accounting = require("accounting");
const { moment } = require("../../helpers/utils.js");
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
export default {
  components: {
    DrawerTicket: () => import("../tickets/components/Drawer.vue"),
    Epico: () => import("./Epico.vue"),
    Container: () =>
      import("vue-smooth-dnd").then(({ Container }) => Container),
    Draggable: () => import("vue-smooth-dnd").then(({ Draggable }) => Draggable)
  },
  name: "Epicos",
  data() {
    return {
      modal_loading: false,
      aviso: {
        isAviso: false,
        id_epico: 0,
        desativar: true
      },
      expanded: false,
      permissao: false,
      epicos: [],
      epico: {
        expanded: false
      },
      enableDrag: true,
      widthDrawer: 850,
      edit_epico: {
        active: false,
        uuid: ""
      },
      columns: [
        {
          type: "expand",
          width: "5%",
          render: (h, params) => {
            return h("div", [
              h(
                "Card",
                {
                  props: { "dis-hover": true },
                  style: {
                    marginBottom: "20px"
                  }
                },
                [
                  h("Divider", { props: { orientation: "left" } }, "Descrição"),
                  h({
                    template: `<div>${params.row.description}</div>`
                  })
                ]
              ),
              h(
                "Card",
                {
                  props: { "dis-hover": true },
                  style: {
                    marginBottom: "20px"
                  }
                },
                [
                  h("h4", [h("p", [`1  - Strategy`])]),
                  h(
                    "Divider",
                    { props: { orientation: "left" } },
                    "1.1 Our Client"
                  ),

                  h({
                    template: `<div>${params.row.strategy.ourClient}</div>`
                  }),

                  h(
                    "Divider",
                    { props: { orientation: "left" } },
                    "1.2 Our Product"
                  ),
                  h({
                    template: `<div>${params.row.strategy.ourProduct}</div>`
                  })
                ]
              ),
              h(
                "Card",
                {
                  props: { "dis-hover": true },
                  style: {
                    marginBottom: "20px"
                  }
                },
                [
                  h("h4", [h("p", [`2 - Customer View`])]),
                  h(
                    "Divider",
                    { props: { orientation: "left" } },
                    "2.1 Customer Problem"
                  ),

                  h({
                    template: `<div>${params.row.customer_view.customerProblem}</div>`
                  }),

                  h(
                    "Divider",
                    { props: { orientation: "left" } },
                    "2.2 Target Market"
                  ),
                  h({
                    template: `<div>${params.row.customer_view.targetMarket}</div>`
                  })
                ]
              ),
              h(
                "Card",
                {
                  props: { "dis-hover": true },
                  style: {
                    marginBottom: "20px"
                  }
                },
                [
                  h("h4", [h("p", [`3 - Market Competitors`])]),
                  h(
                    "Divider",
                    { props: { orientation: "left" } },
                    "3.1 Competitors"
                  ),
                  h({
                    template: `<div>${params.row.market_competitors.competitors}</div>`
                  })
                ]
              ),
              h(
                "Card",
                {
                  props: { "dis-hover": true },
                  style: {
                    marginBottom: "20px"
                  }
                },
                [
                  h("h4", [h("p", [`4 - Hack Relevancy`])]),
                  h("Divider", { props: { orientation: "left" } }, "4.1 OKRs"),

                  h({
                    template: `<div>${params.row.hack_relevancy.okrs}</div>`
                  }),

                  h(
                    "Divider",
                    { props: { orientation: "left" } },
                    "4.2 KPI Sucess"
                  ),
                  h({
                    template: `<div>${params.row.hack_relevancy.kpiSucess}</div>`
                  })
                ]
              ),
              h(
                "Card",
                {
                  props: { "dis-hover": true },
                  style: {
                    marginBottom: "20px"
                  }
                },
                [
                  h("Divider", { props: { orientation: "left" } }, "Histórico"),
                  h({
                    template: `<div>Última atualização feita por <strong>${
                      params.row.update_by
                    }</strong> em ${moment(params.row.update_at).format(
                      "DD/MM/YYYY hh:mm"
                    )}. </br> Épico criado por <strong>${
                      params.row.owner
                    }</strong> em ${moment(params.row.create_at).format(
                      "DD/MM/YYYY hh:mm"
                    )}.</div>`
                  })
                ]
              )
            ]);
          }
        },
        {
          title: "",
          key: "posicao",
          width: "5%",
          render: (h, params) => {
            return h("Tag", params.row.id);
          }
        },
        {
          title: "Épico",
          key: "nome",
          width: "30%",
          height: 30,
          sortable: true,
          render: (h, params) => {
            return h("h4", [h("p", [`${params.row.name}`])]);
          }
        },
        {
          title: "Owner",
          width: "12%",
          render: (h, params) => {
            return h("p", `${params.row.owner}`);
          }
        },
        {
          title: "Squad",
          width: "12%",
          render: (h, params) => {
            return h("p", `Squad ${params.row.squad}`);
          }
        },
        {
          title: "Produto",
          width: "15%",
          render: (h, params) => {
            return h("p", `${params.row.product}`);
          }
        },
        {
          title: "Tema",
          width: "15%",
          render: (h, params) => {
            return h("p", `${params.row.theme}`);
          }
        },
        {
          title: "",
          width: "3%",
          render: (h, params) => {
            return h("VxOptionsUUID", {
              attrs: {
                id: params.row.id,
                onSelect: this.opcaoEpico,
                uuid: params.row.uuid,
                options: [
                  {
                    icone: "md-create",
                    label: "Editar",
                    textColor: "#00bfa5"
                  },
                  {
                    icone: "md-close",
                    label: "Fechar",
                    textColor: "#ff5252"
                  },
                  {
                    icone: "",
                    label: "Sem permissão",
                    textColor: "#ff5252"
                  }
                ].filter(item => {
                  if (item.label === "Editar") {
                    if (this.permissoes.editar()) {
                      return item;
                    }
                  } else if (item.label === "Fechar") {
                    if (this.permissoes.fechar()) {
                      return item;
                    }
                  } else if (item.label === "Sem permissão") {
                    if (!this.permissoes.editar()) {
                      return item;
                    }
                  }
                })
              }
            });
          }
        }
      ],
      projetos: []
    };
  },
  computed: {
    ...mapGetters(["idUser", "roleUser", "isTester", "currentUser"]),

    //obter as permissões do usuário logado
    permissoes() {
      return {
        arrastar: () => {
          /**
           * Permissão: Administração, Coordenador de Suporte ou Coordenador de Desenvolvimento
           */

          return [1, 29, 34].includes(this.roleUser);
        },
        editar: () => {
          /**
           * Permissão: Administração, Coordenador de Suporte ou Coordenador de Desenvolvimento
           */

          return [1, 29, 34].includes(this.roleUser);
        },
        fechar: () => {
          /**
           * Permissão: Administração, Coordenador de Suporte ou Coordenador de Desenvolvimento
           */

          return [1, 29, 34].includes(this.roleUser);
        }
      };
    },

    widthCel() {
      return `${90 / (this.columns.length - 2)}%`;
    }
  },
  created() {
    this.$Spin.show();
    this.getEpicos();
    this.permissaoBotao();
  },
  methods: {
    //expandir o item selecionado
    expandir(index) {
      this.epicos[index].expanded = !this.epicos[index].expanded;
      this.expanded = !this.expanded;
    },

    //caso a permissão do usuário seja 1, 29 ou 34 ele possui permissão para arrastar/add/fechar épicos
    permissaoBotao() {
      if (this.roleUser == 1 || this.roleUser == 29 || this.roleUser == 34) {
        this.permissao = true;
      }
    },

    //ações do épico | Edita ou Fecha
    async opcaoEpico(id, uuid, opcao) {
      if (opcao === "Editar") {
        this.editProject(uuid);
      } else if (opcao === "Fechar") {
        const URI = `${process.env.VUE_APP_API_URL}epico/`;
        const data = await this.$axios.delete(`${URI}${uuid}`);
        if (data.status == 200) {
          this.$Message.success("Épico fechado com sucesso!");
          this.getEpicos();
        } else {
          this.$Message.error("Oops, ocorreu algum erro. Tente novamente.");
          this.getEpicos();
        }
      }
    },

    /**
     * Faz a consulta dos épicos
     */
    async getEpicos() {
      try {
        const URI = `epico`;
        //get na url /epico para recuperar os épicos cadastrados
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL}${URI}`,
          {
            params: { active: "sort" }
          }
        );

        const epicos = response.data.data.map(epico => {
          epico.expanded = false;
          this.epicos = response.data.data;

          return epicos;
        });

        this.$Spin.hide();
        return epicos;
      } catch (ex) {
        console.warn(ex);
        this.$Spin.hide();
      }
    },
    /**
     * Método que permite reordenar os projetos de acordo com o arraste
     */
    onDrop({ removedIndex, addedIndex, payload }) {
      if (this.permissoes.arrastar()) {
        const arr = this.epicos;

        if (removedIndex === null || addedIndex === null) return;
        let result = [...arr];
        let itemToAdd = payload;
        removedIndex = result.findIndex(
          pj => pj.id == this.epicos[removedIndex].id
        );
        addedIndex = result.findIndex(
          pj => pj.id == this.epicos[addedIndex].id
        );
        itemToAdd = result.splice(removedIndex, 1)[0];

        const id = itemToAdd.id;
        const uuid = itemToAdd.uuid;
        const pos_atual = parseFloat(itemToAdd.list_order);
        const pos_nova = parseFloat(arr[addedIndex].list_order);

        //se a posição nova for maior que a posição antiga + 0.1

        result = this.atualizarPosicao(result, pos_nova, pos_atual);
        itemToAdd.posicao = pos_nova;
        result.splice(addedIndex, 0, itemToAdd);
        this.epicos = result;

        if (pos_nova > pos_atual) {
          const posicao = pos_nova + 0.001;
          this.atualizarPosicaoDB(uuid, posicao, pos_atual);
        } else {
          const posicao = pos_nova - 0.001;
          this.atualizarPosicaoDB(uuid, posicao, pos_atual);
        }
      } else {
        this.$Message.error("Você não tem permissão para isso. ¯\\_(ツ)_/¯");
      }
    },
    //atualiza posição no array
    atualizarPosicao(arr, posicao, pos_atual) {
      return arr.map(item => {
        if (posicao > pos_atual) {
          item.posicao -=
            item.posicao > pos_atual && item.posicao <= posicao ? 0.001 : 0;
        } else {
          item.posicao +=
            item.posicao < pos_atual && item.posicao >= posicao ? 0.001 : 0;
        }
        return item;
      });
    },
    //atualiza posição no banco de dados
    async atualizarPosicaoDB(uuid, posicao, pos_atual) {
      try {
        let response = await this.$axios.put(`epico/${uuid}/${posicao}`);

        return this.getEpicos();
      } catch (error) {
        console.warn(error);
        this.getEpicos();
      }
    },
    //novo épico com validação de permissão
    newEpico() {
      if (this.permissoes.editar()) {
        this.edit_epico.uuid = 0;
        this.edit_epico.active = true;
      } else {
        this.$Message.error("Você não tem permissão para isso.");
      }
    },
    editProject(uuid) {
      this.edit_epico.uuid = uuid;
      this.edit_epico.active = true;
    },
    onUpdate(epic) {
      const idxProj = this.epicos.findIndex(proj => proj.id === epic.id);

      if (idxProj > -1) {
        this.epicos.splice(idxProj, 1, {
          ...this.epicos[idxProj],
          ...epic
        });
      } else {
        this.edit_epico.active = false;
        this.epicos.push({
          ...epic
        });
      }

      this.getEpicos();

      this.$forceUpdate();
    },

    verifyWidth(windowWidth) {
      this.enableDrag = !this.iOS && windowWidth > 700;
      this.widthDrawer = windowWidth < 850 ? windowWidth : 850;
    },
    handleWindowResize: debounce(function(event) {
      this.verifyWidth(event.currentTarget.innerWidth);
    }, 400)
  },
  mounted() {
    this.iOS =
      /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && !window.MSStream;
    this.verifyWidth(window.innerWidth);
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  }
};
</script>

<style scoped>
.transition {
  transition: font 0.2s ease-in;
}
</style>

<style>
table {
  display: table;
  border-collapse: separate;
  width: 100%;
}
</style>
